<template>
	<div class="msg-center-container">
		<div class="content-container">
			<!-- 面包屑导航 -->
			<div class="breadcrumb">
				<router-link to="/" class="breadcrumb-item">首页</router-link>
				<span class="breadcrumb-separator">></span>
				<span class="breadcrumb-item current">消息中心</span>
			</div>
			<div class="msgCenterListBox">
				<!-- 消息分类导航 -->
				<div class="msg-center-nav">
					<div class="msg-categories">
						<div v-for="category in categories" :key="category.key" class="category-item"
							:class="{ 'active': activeCategory === category.key }"
							@click="switchCategory(category.key)">
							{{ category.name }}
						</div>
					</div>
					<div class="read-all-btn" @click="markAllAsRead">
						全部已读
					</div>
				</div>

				<!-- 消息状态筛选 -->
				<div class="msg-status-filter">
					<div v-for="status in statuses" :key="status.key" class="status-item"
						:class="{ 'active': activeStatus === status.key }" @click="switchStatus(status.key)">
						{{ status.name }}
						<span v-if="status.count">({{ status.count }})</span>
					</div>
				</div>

				<!-- 消息列表 -->
				<div class="msgCenterList">
					<router-link to="/msg-details" class="msgType" v-for="(item,index) in filteredMessages"
						:key="index">
						<div class="msgTypeIconBox">
							<img class="msgTypeIcon" :src="item.icon" />
							<div class="redPoint" v-if="item.isNewMsg"></div>
						</div>
						<div class="msgTypeTitleBox">
							<div class="msgTypeTitle">{{item.title}}</div>
							<div class="msgTypeContent ellipsis-1">站内通知>订单消息｜2025-08-16 16:34 <span
									class="lookDetails">查看详情<img src="../assets/Home/msgArrow.png" alt="" /></span>
							</div>
						</div>
					</router-link>
				</div>

				<!-- 分页组件 -->
				<PagePagination style="padding: .4rem 0 .32rem;" :currentPage="currentPage" :total="total"
					@current-change="onPageChange" />
			</div>
		</div>
	</div>
</template>

<script>
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'MsgCenter',
		components: {
			PagePagination
		},
		data() {
			return {
				currentPage: 1, // 当前页码
				total: 1000, // 总条数
				msgTypeData: [
					// 平台公告
					{
						title: '平台公告 - 系统更新通知',
						content: '尊敬的用户，我们的系统将于今晚23:00-次日凌晨2:00进行维护更新，期间可能出现短暂服务中断。',
						isNewMsg: true,
						icon: require('@/assets/platformMsg.png'),
						type: 'platform',
						time: '2023-11-21 10:30'
					},
					{
						title: '平台公告 - 新功能上线',
						content: '我们很高兴地宣布，全新的个人中心功能已正式上线，欢迎体验！',
						isNewMsg: false,
						icon: require('@/assets/platformMsg.png'),
						type: 'platform',
						time: '2023-11-20 15:45'
					},
					// 活动通知
					{
						title: '活动通知 - 绘画大赛开始报名',
						content: '2023年度绘画大赛已开始报名，点击了解详情并参与！',
						isNewMsg: true,
						icon: require('@/assets/activityMsg.png'),
						type: 'activity',
						time: '2023-11-21 09:15'
					},
					{
						title: '活动通知 - 限时优惠',
						content: '限时优惠活动进行中，会员专享8折优惠！',
						isNewMsg: false,
						icon: require('@/assets/activityMsg.png'),
						type: 'activity',
						time: '2023-11-19 14:20'
					},
					// 站内消息
					{
						title: '站内消息 - 您的作品获得点赞',
						content: '用户"艺术爱好者"赞了您的作品《山水意境》。',
						isNewMsg: true,
						icon: require('@/assets/inMsg.png'),
						type: 'internal',
						time: '2023-11-21 11:05'
					},
					{
						title: '站内消息 - 收到新评论',
						content: '用户"墨染宣纸"评论了您的作品。',
						isNewMsg: false,
						icon: require('@/assets/inMsg.png'),
						type: 'internal',
						time: '2023-11-20 16:30'
					}
				],
				// 分类导航
				categories: [{
						key: 'all',
						name: '全部消息'
					},
					{
						key: 'internal',
						name: '站内消息'
					},
					{
						key: 'activity',
						name: '活动通知'
					},
					{
						key: 'platform',
						name: '平台公告'
					}
				],
				// 状态筛选
				statuses: [{
						key: 'all',
						name: '全部',
						count: 124
					},
					{
						key: 'unread',
						name: '未读',
						count: 2
					}
				],
				// 当前选中的分类和状态
				activeCategory: 'all',
				activeStatus: 'all'
			}
		},
		computed: {
			// 根据分类和状态筛选消息
			filteredMessages() {
				let messages = [...this.msgTypeData];

				// 按分类筛选
				if (this.activeCategory !== 'all') {
					messages = messages.filter(msg => msg.type === this.activeCategory);
				}

				// 按状态筛选
				if (this.activeStatus === 'unread') {
					messages = messages.filter(msg => msg.isNewMsg);
				}

				return messages;
			}
		},
		methods: {
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				console.log(`切换到第${newPage}页`)
			},

			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.currentPage = 1; // 切换分类时重置到第一页
				console.log(`切换到${category}分类`);
			},

			// 切换状态
			switchStatus(status) {
				this.activeStatus = status;
				this.currentPage = 1; // 切换状态时重置到第一页
				console.log(`切换到${status}状态`);
			},

			// 标记全部为已读
			markAllAsRead() {
				// 根据当前选中的分类和状态，将符合条件的消息标记为已读
				this.msgTypeData.forEach(msg => {
					const matchesCategory = this.activeCategory === 'all' || msg.type === this.activeCategory;
					const matchesStatus = this.activeStatus === 'all' || (this.activeStatus === 'unread' && msg
						.isNewMsg);

					if (matchesCategory && matchesStatus) {
						msg.isNewMsg = false;
					}
				});

				// 更新状态计数
				this.statuses.find(s => s.key === 'unread').count =
					this.msgTypeData.filter(msg => msg.isNewMsg).length;

				console.log('已将符合条件的消息标记为已读');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.msg-center-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	/* 面包屑导航样式 */
	.breadcrumb {
		margin-top: .32rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}

	.msgCenterListBox {
		margin-top: .24rem;
		width: 12rem;
		border-radius: .08rem;
		background: #FFFFFF;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
		padding: 0 .24rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.read-all-btn {
		font-weight: 400;
		font-size: .14rem;
		color: #E29358;
		cursor: pointer;
		transition: color 0.3s ease;
	}

	.read-all-btn:hover {
		color: #D17F3A;
	}

	/* 消息状态筛选样式 */
	.msg-status-filter {
		display: flex;
		padding: .16rem 0 .08rem;
	}

	.status-item {
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
		cursor: pointer;
		padding: .08rem .16rem .06rem;
		background: rgba(226, 147, 88, .3);
		margin-right: .12rem;
		border-radius: .04rem;
		transition: all 0.3s ease;
	}

	.status-item.active {
		background-color: #E29358;
		font-weight: 500;
		color: #252525;
	}

	/* 消息列表样式 */
	.msgCenterList {
		padding: 0 .32rem;
	}

	.msgType {
		display: flex;
		align-items: center;
		height: 1rem;
		border-bottom: 1px solid #F0F0F0;
		transition: background-color 0.3s ease;
	}

	a:hover {
		text-decoration: none !important;
	}

	.msgType:hover {
		background-color: #F9F9F9;
	}

	.msgTypeIconBox {
		position: relative;
		margin-right: .16rem;
	}

	.msgTypeIcon {
		width: .48rem;
		height: .48rem;
	}

	.redPoint {
		position: absolute;
		top: -0.04rem;
		right: -0.04rem;
		width: .16rem;
		height: .16rem;
		background-color: #FF0000;
		border-radius: 50%;
		border: 2px solid #FFFFFF;
	}

	.msgTypeTitleBox {
		flex: 1;
	}

	.msgTypeTitle {
		font-size: .16rem;
		font-weight: 500;
		color: #333333;
		margin-bottom: .08rem;
	}

	.msgTypeContent {
		display: flex;
		align-items: center;
		font-size: .14rem;
		color: #606266;

		.lookDetails {
			margin-left: .16rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #A88653;

			img {
				margin-left: .04rem;
				width: .05rem;
				height: .08rem;
			}
		}
	}
</style>